const getEntityMarker = (realm) => realm.blueprint.type === "listEntity" ? realm.blueprint.parent.blueprint.marker : realm.blueprint.marker;
export {
  getEntityMarker
};
//# sourceMappingURL=getEntityMarker.js.map
